import { render, staticRenderFns } from "./Types.vue?vue&type=template&id=1edcd2ab&scoped=true&"
import script from "./Types.vue?vue&type=script&lang=js&"
export * from "./Types.vue?vue&type=script&lang=js&"
import style0 from "./Types.vue?vue&type=style&index=0&id=1edcd2ab&lang=scss&scoped=true&"
import style1 from "./Types.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edcd2ab",
  null
  
)

export default component.exports